import { render } from "./ClassBrief.vue?vue&type=template&id=37eb73a1&scoped=true"
import script from "./ClassBrief.vue?vue&type=script&lang=js"
export * from "./ClassBrief.vue?vue&type=script&lang=js"

import "./ClassBrief.vue?vue&type=style&index=0&id=37eb73a1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37eb73a1"]])

export default __exports__